import { graphql, useStaticQuery } from "gatsby";

import { ICommercialPhoneAndAccountCodeHook } from "@models/hooks";

const useCommercialPhoneAndAccountCode = () => {
  const data = useStaticQuery<ICommercialPhoneAndAccountCodeHook>(graphql`
    {
      commercial {
        phone_number
        account_code
      }
    }
  `);
  return data.commercial;
};
export default useCommercialPhoneAndAccountCode;
